import { useEffect } from 'react';
import HorizontalNewsResponsive from '../HorizontalNews/HorizontalNewsResponsive';
import './styles.categoryNews.scss';
interface Props {
    categoryNews: any[];
    numberNews: any;
}

const CategoryNewsContainerResponsive = (props: Props) => {

    useEffect(() => {
        console.log(props.categoryNews);

    }, [props.categoryNews]);

    return (
        <div className='category-news-container'>
            {(props.categoryNews && props.categoryNews.length > 3) &&
                props.categoryNews.slice(0, 3).map((news: any, index) => (

                    <HorizontalNewsResponsive
                        newsContent={news}
                        newsCategory={''}
                        avgStd={news.avgStd}
                        isSlider={index === 0 ? true : false}
                        numberNews={props.numberNews}
                    />
                ))

            }
        </div>
    )
}



export default CategoryNewsContainerResponsive
